import React from "react";
import "./EndeavorCard.css";

function EndeavorCard({ endeavor, onClick, enrollmentRole }) {
  const isShared = endeavor.isShared === true;
  const buildMetaMap = () => {
    const map = {};
    const raw = endeavor.metadata || endeavor.metadataItems || endeavor.metadataValues || [];
    raw.forEach(item => {
      const name =
        item?.metadataDefinition?.name ||
        item?.metadataName ||
        item?.name;
      const val = item?.value ?? item?.val ?? item?.text;
      if (name && (val || val === 0)) map[name.toLowerCase()] = val;
    });
    return map;
  };
  const meta = buildMetaMap();

  const name =
    endeavor.name ||
    meta["course name"] ||
    endeavor.title ||
    "Untitled Course";

  const professor =
    endeavor.professorName ||
    endeavor.instructorName ||
    endeavor.professor ||
    endeavor.instructor ||
    meta["professor"] ||
    "";

  const code =
    endeavor.courseCode ||
    endeavor.code ||
    meta["course code"] ||
    meta["code"] ||
    "";

  const location =
    endeavor.location ||
    endeavor.courseLocation ||
    endeavor.room ||
    endeavor.roomNumber ||
    meta["course location"] ||
    meta["location"] ||
    "";

  const meetingTimes =
    endeavor.meetingTimes ||
    endeavor.meetingSchedule ||
    meta["meeting times"] ||
    meta["meeting_times"] ||
    meta["meeting time"] ||
    meta["meeting schedule"] ||
    meta["schedule"] ||
    meta["meeting days"] ||
    meta["meeting_days"] ||
    "";

  const officeHours =
    endeavor.officeHours ||
    meta["office hours"] ||
    meta["office_hours"] ||
    "";

  const startDateRaw = meta["start date"] || meta["start_date"];
  const endDateRaw   = meta["end date"]   || meta["end_date"];

  const fmtDate = (d) => {
    try {
      if (!d) return "";
      const dt = new Date(d);
      if (isNaN(dt)) return "";
      return dt.toLocaleDateString("en-US", { month: "short", day: "numeric" });
    } catch { return ""; }
  };
  const dateRange = (startDateRaw && endDateRaw)
    ? `${fmtDate(startDateRaw)} – ${fmtDate(endDateRaw)}`
    : "";

  // Row 2 left (exclude course code now that it's on top row)
  const leftPrimary = professor || meetingTimes || location || "";

  // Row 2 right (only location if not already used)
  const rightItems = [location].filter(v => v && v !== leftPrimary);

  const extraItems = [];
  if (meetingTimes && meetingTimes !== leftPrimary) extraItems.push(meetingTimes);
  if (dateRange) extraItems.push(dateRange);
  if (officeHours) extraItems.push(`Office Hours: ${officeHours}`);

  return (
    <div
      className="assignment-item endeavor-as-assignment"
      role="button"
      tabIndex={0}
      onClick={onClick}
    >
      <div className="assignment-content">
        {/* Top row: Course name left, Course code + badges right */}
        <div className="endeavor-top-row">
          <h4 className="assignment-title single-line">{name}</h4>
          <div className="endeavor-top-badges">
            {isShared && (
              <span className="endeavor-badge endeavor-badge--shared" title="Shared course">
                👥 Shared
              </span>
            )}
            {isShared && enrollmentRole && (
              <span className={`endeavor-badge endeavor-badge--role endeavor-badge--${enrollmentRole}`} title={enrollmentRole}>
                {enrollmentRole.charAt(0).toUpperCase() + enrollmentRole.slice(1)}
              </span>
            )}
            {code && (
              <span className="endeavor-code" title={code}>
                {code}
              </span>
            )}
          </div>
        </div>

        <div className="assignment-row">
          <span className="due-date-text">
            {leftPrimary || "\u00A0"}
          </span>
          {rightItems.length > 0 && (
            <div className="endeavor-meta-right">
              {rightItems.map((v, i) => (
                <span key={i} className="endeavor-meta" title={v}>{v}</span>
              ))}
            </div>
          )}
        </div>

        {extraItems.length > 0 && (
          <div className="endeavor-extra-row">
            {extraItems.map((v, i) => (
              <span key={i} className="endeavor-extra-item" title={v}>
                {v}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default EndeavorCard;